import { useEffect } from 'react'

import { useTags } from '../api'
import { useTagsStore } from '../store'

export const useGlobalOrgTags = () => {
  // Fetch available tags from API
  const { globalOrgTags, setGlobalOrgTags } = useTagsStore()
  const { data: apiTags, isLoading: isApiLoading } = useTags({ pageSize: 300, page: 1 })

  // Update the store with the fetched tags
  useEffect(() => {
    if (apiTags?.results) {
      setGlobalOrgTags(apiTags.results)
    }
  }, [apiTags?.results, setGlobalOrgTags])

  return { globalOrgTags, isLoading: isApiLoading }
}
